<template lang="pug">
	.tiptap-image-link
		router-link.anchor(v-if="link.kind === 'router'", :to="link.to", :aria-label="label", :class="{ loading: !loaded }")
			img(:src="src", :alt="alt", loading="lazy", decoding="async", @load="loaded = true", @error="loaded = true")
		a.anchor(
			v-else,
			:href="link.href",
			:target="external ? '_blank' : null",
			:rel="external ? 'noopener noreferrer' : null",
			:aria-label="label",
			:class="{ loading: !loaded }"
		)
			img(:src="src", :alt="alt", loading="lazy", decoding="async", @load="loaded = true", @error="loaded = true")
</template>

<script>
export default {
	name: 'component-tiptap-image-link',
	props: {
		src: {
			type: String,
			required: true,
		},
		alt: {
			type: String,
			default: '',
		},
		link: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			loaded: false,
		}
	},
	computed: {
		external() {
			return this.link.kind === 'external'
		},
		label() {
			if (this.alt) return null
			return this.external ? 'Abrir link em nova aba' : 'Abrir link'
		},
	},
	watch: {
		src() {
			this.loaded = false
		},
	},
}
</script>

<style lang="stylus" scoped src="./ImageLink.styl"></style>
